// THE SHAPE OF A ROW ON THIS PAGE — the client's colour, who or what it is, its state,
// its date, the line that says what it is about, and where it takes you.
//
// A task and a lead follow-up are DIFFERENT THINGS and stay in different sections (see
// MyDay.js), but they are the same shape on screen: the distinction worth carrying is the
// WORDS inside, not the geometry around them. So the frame is shared and the two callers
// fill it.
//
// It is deliberately NOT the bell's AlertShell, though the two look alike. That one lives
// inside a dropdown panel that closes itself on navigation and is built around
// `he.alerts`; this is a page row. Sharing them would have meant one component carrying
// both sets of behaviour, and an edit to the bell — a file three other sessions are in —
// for every change to this page. What the two genuinely share is the routing rule, and
// they share it: utils/boardLink.
import { Link } from 'react-router-dom';
import he from '../../i18n/he';
import DateText from '../../components/DateText';

export default function DayRow({ to, late, color, name, date, children, foot, go }) {
  return (
    <Link to={to} className={`day-row${late ? ' is-late' : ''}`}>
      <span className="day-row-head">
        <span className="swatch" style={{ background: color || 'var(--muted)' }} />
        <span className="day-row-name">{name}</span>
        <span className={`badge ${late ? 'red' : 'amber'}`}>
          {late ? he.myDay.late : he.myDay.dueToday}
        </span>
        <span className="day-row-date"><DateText value={date} /></span>
      </span>
      {children}
      <span className="day-row-foot">
        {foot}
        <span className="day-row-go">{go}</span>
      </span>
    </Link>
  );
}
